import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequireAuth({ children }) {
  const { user } = useAuth();
  if (user === undefined) return null; // still checking the session — avoid a login flash
  if (user === null) return <Navigate to="/" replace />;
  return children;
}
